import { useContext, useEffect, useState } from 'react'
import DataContext from 'src/contexts/DataContext'
import { TCourses, courseTypesToNames } from 'src/contexts/tools'
import { ICourseInfo, useGetRegisterTypesLazy } from 'src/services/backend'

interface ICourseInfoHookProps {
  course: TCourses
}

const useCourseInfoHook = ({ course }: ICourseInfoHookProps): ICourseInfo => {
  const [courses, setCourses] = useState<any>({})
  const [coursesInfos, setCoursesInfos] = useState<any[]>([])
  const [currentCourse, setCurrentCourse] = useState<TCourses>()
  const [currentCourseInfo, setCurrentCourseInfo] = useState<ICourseInfo>()

  const { registration, setRegistration } = useContext(DataContext)

  const [getRegisterTypes, getRegisterTypesResult] = useGetRegisterTypesLazy()

  useEffect(() => {
    getRegisterTypes()
  }, [])

  useEffect(() => {
    if (getRegisterTypesResult?.data) {
      const courses: any = {}
      getRegisterTypesResult?.data?.response?.forEach((course: any) => {
        courses[course?.name] = course?.pk_id
      })
      setCourses(courses)
      setCoursesInfos(getRegisterTypesResult?.data?.response)
    }
  }, [getRegisterTypesResult?.data])

  useEffect(() => {
    if (Object.keys(courses).length && currentCourse) {
      localStorage.setItem('course', currentCourse)
      setCurrentCourseInfo(
        coursesInfos.filter(
          (course) => course.name === courseTypesToNames(currentCourse)
        )[0]
      )
    }
  }, [courses])

  useEffect(() => {
    registration.course
      ? setCurrentCourse(registration.course)
      : setCurrentCourse(course)
  }, [registration.course])

  useEffect(() => {
    if (currentCourseInfo) {
      setRegistration((prevState: any) => ({
        ...prevState,
        minBirthdate: currentCourseInfo.min_birthdate,
        maxBirthdate: currentCourseInfo.max_birthdate,
        courseYear: currentCourseInfo.year,
        courseTypeId: currentCourseInfo.pk_id,
      }))
    }
  }, [currentCourseInfo])

  return currentCourseInfo!
}

export { useCourseInfoHook }
